import ApiProvider from 'src/core/ApiProvider';
import { UserInfo, UserLoginInfo, UserPasswordInfo, UserRegisterInfo } from 'src/core/types/User';
import { ResponseContext } from 'src/core/api/ProviderContext';

export default {
  userLogin: ({ email, password, session }: Readonly<UserLoginInfo>) => {
    return ApiProvider({
      email,
      password,
      session,
      methodName: 'Module/Kullanicilar/Login',
    });
  },
  userRegister: ({ nameSurname, email, password, passwordAgain, birthday }: Readonly<UserRegisterInfo>) => {
    return ApiProvider({
      nameSurname,
      email,
      password,
      passwordAgain,
      birthday,
      methodName: 'Module/Kullanicilar/Register',
    });
  },
  userDetail: () => {
    return ApiProvider({
      methodName: 'Module/Kullanicilar/UserDetailWeb',
    });
  },
  updateUser: ({ nameSurname, email, birthday, gender, telephone }: Readonly<UserInfo>) => {
    return ApiProvider({
      nameSurname,
      email,
      birthday,
      gender,
      telephone,
      methodName: 'Module/Kullanicilar/UpdateUser',
    });
  },
  updatePassword({ oldPassword, password, passwordAgain }: Readonly<UserPasswordInfo>): Promise<ResponseContext> {
    return ApiProvider({
      oldPassword,
      password,
      passwordAgain,
      methodName: 'Module/Kullanicilar/UpdatePassword',
    });
  },
};
